"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestTxSig = exports.requestAccountAddress = exports.waitForSignedTxs = exports.waitForAccountAuth = exports.valoraLocalStorageKey = exports.SignTxRequest = exports.serializeDappKitRequestDeeplink = exports.AccountAuthRequest = void 0;
var utils_1 = require("@celo/utils");
var linking_1 = __importDefault(require("./linking"));
var utils_2 = require("@celo/utils");
Object.defineProperty(exports, "AccountAuthRequest", { enumerable: true, get: function () { return utils_2.AccountAuthRequest; } });
Object.defineProperty(exports, "serializeDappKitRequestDeeplink", { enumerable: true, get: function () { return utils_2.serializeDappKitRequestDeeplink; } });
Object.defineProperty(exports, "SignTxRequest", { enumerable: true, get: function () { return utils_2.SignTxRequest; } });
exports.valoraLocalStorageKey = 'use-contractkit/dappkit';
// hack to get around deeplinking issue where new tabs are opened
// and the url hash state is not respected (Note this implementation
// of dappkit doesn't use URL hashes to always force the newtab experience).
var checkUrlValora = function (onTrue) {
    if (typeof window !== 'undefined') {
        var nonHashUrl = window.location.href.replace('/#', '');
        var params = new URL(nonHashUrl).searchParams;
        if (params.get('type') && params.get('requestId')) {
            localStorage.setItem(exports.valoraLocalStorageKey, nonHashUrl);
            onTrue && onTrue();
        }
    }
};
if (typeof window !== 'undefined') {
    checkUrlValora(window.close);
}
function clearParams() {
    var whereQuery = window.location.href.indexOf('?');
    if (whereQuery) {
        window.location.href = window.location.href.substring(0, whereQuery);
    }
}
function waitForResponse() {
    return __awaiter(this, void 0, void 0, function () {
        var value;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    value = localStorage.getItem(exports.valoraLocalStorageKey);
                    if (!value) {
                        checkUrlValora(clearParams);
                        value = localStorage.getItem(exports.valoraLocalStorageKey);
                    }
                    if (value) {
                        return [2 /*return*/, value];
                    }
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 1000); })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [3 /*break*/, 0];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function waitForAccountAuth(requestId) {
    return __awaiter(this, void 0, void 0, function () {
        var url, dappKitResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, waitForResponse()];
                case 1:
                    url = _a.sent();
                    dappKitResponse = utils_1.parseDappkitResponseDeeplink(url);
                    if (requestId === dappKitResponse.requestId &&
                        dappKitResponse.type === utils_1.DappKitRequestTypes.ACCOUNT_ADDRESS &&
                        dappKitResponse.status === utils_1.DappKitResponseStatus.SUCCESS) {
                        return [2 /*return*/, dappKitResponse];
                    }
                    throw new Error('Unable to parse Valora response');
            }
        });
    });
}
exports.waitForAccountAuth = waitForAccountAuth;
function waitForSignedTxs(requestId) {
    return __awaiter(this, void 0, void 0, function () {
        var url, dappKitResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, waitForResponse()];
                case 1:
                    url = _a.sent();
                    dappKitResponse = utils_1.parseDappkitResponseDeeplink(url);
                    if (requestId === dappKitResponse.requestId &&
                        dappKitResponse.type === utils_1.DappKitRequestTypes.SIGN_TX &&
                        dappKitResponse.status === utils_1.DappKitResponseStatus.SUCCESS) {
                        return [2 /*return*/, dappKitResponse];
                    }
                    console.warn('Unable to parse url', url);
                    throw new Error('Unable to parse Valora response');
            }
        });
    });
}
exports.waitForSignedTxs = waitForSignedTxs;
function requestAccountAddress(meta) {
    localStorage.removeItem(exports.valoraLocalStorageKey);
    var deepLink = utils_1.serializeDappKitRequestDeeplink(utils_1.AccountAuthRequest(meta));
    linking_1.default.openURL(deepLink);
}
exports.requestAccountAddress = requestAccountAddress;
function requestTxSig(kit, txParams, meta) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var baseNonce, txs, request;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    localStorage.removeItem(exports.valoraLocalStorageKey);
                    return [4 /*yield*/, kit.connection.nonce((_a = txParams[0]) === null || _a === void 0 ? void 0 : _a.from)];
                case 1:
                    baseNonce = _b.sent();
                    txs = txParams.map(function (txParam, index) {
                        var _a;
                        var value = txParam.value === undefined ? '0' : txParam.value;
                        return __assign({ txData: txParam.data, estimatedGas: (_a = txParam.gas) !== null && _a !== void 0 ? _a : 150000, nonce: baseNonce + index, feeCurrencyAddress: undefined, value: value }, txParam);
                    });
                    request = utils_1.SignTxRequest(txs, meta);
                    linking_1.default.openURL(utils_1.serializeDappKitRequestDeeplink(request));
                    return [2 /*return*/];
            }
        });
    });
}
exports.requestTxSig = requestTxSig;
//# sourceMappingURL=dappkit.js.map